import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import { useIntl } from '@grandvisionhq/state';

const PaypalClientConfigurationContext = /*#__PURE__*/ React.createContext(undefined);
const usePaypalClientConfiguration = ()=>React.useContext(PaypalClientConfigurationContext)
;
const PaypalClientProvider = ({ children , settings ,  })=>{
    const { currency , locale  } = useIntl();
    return /*#__PURE__*/ React.createElement(PaypalClientConfigurationContext.Provider, {
        value: settings
    }, settings ? /*#__PURE__*/ React.createElement(PayPalScriptProvider, {
        options: swcHelpers.objectSpread({}, settings.options, {
            locale: locale.replace('-', '_'),
            currency,
            components: 'buttons'
        })
    }, children) : children);
};

export { PaypalClientProvider, usePaypalClientConfiguration };
//# sourceMappingURL=PaypalClientConfigurationContext.js.map
